import React from "react";
import Media from "react-media";
import { withTheme } from "styled-components";
export const withDefaultMedia = WrappedComponent => {
  return withTheme(props => {
    return /*#__PURE__*/React.createElement(Media, {
      queries: props.theme.media
    }, /*#__PURE__*/React.createElement(WrappedComponent, props));
  });
};